import {atom} from 'recoil';

export const generatedItem = atom<{category: string; price: number; descr: string; images: string} | undefined>({
  key: 'item-generate',
  default: undefined,
});
